import { Key } from 'react';
import useSWR, { SWRConfiguration } from 'swr';
import { PaymentModuleKey } from '../types';

export interface PaymentMethod {
    /** Mollie method id, e.g. "ideal", "creditcard", "paypal" */
    id: string;
    /** Human readable name as Mollie labels it, already localised by Mollie */
    description: string;
    /** Mollie-hosted logo url, null when Mollie did not supply one */
    image: string | null;
}

interface PaymentMethodsResponse {
    data: PaymentMethod[];
}

/**
 * The methods a booker may choose from for a given space: what the club has
 * enabled at Mollie, narrowed to the subset the club offers on that space.
 */
export function useSpacePaymentMethods(spaceId?: Key, enabled = true, options?: SWRConfiguration) {
    return useSWR<PaymentMethodsResponse>(
        spaceId && enabled ? `space-manager/space/${spaceId}/payment-methods` : null,
        null,
        options
    );
}

/**
 * Everything the club has enabled in its Mollie dashboard. Used by admins to
 * pick which of those to offer, so it is intentionally not filtered per space.
 */
export function useClubPaymentMethods(clubSlug?: string, options?: SWRConfiguration, module?: PaymentModuleKey) {
    return useSWR<PaymentMethodsResponse>(
        clubSlug ? `connect/${clubSlug}/payment-methods${module ? `?module=${module}` : ''}` : null,
        null,
        options
    );
}
